module.exports = __webpack_public_path__ + "img/11.accba833.svg";